import _ from 'lodash';

function isReferralforwarded({ serviceCase, referral }) {
  return _.get(referral, 'state') === 'accepted' &&
   !['managed', 'off_platform', 'accepted'].includes(_.get(serviceCase, 'state'));
}

export default isReferralforwarded;
